const token = localStorage.getItem("picketAdmin");

export default token;
